import { fontWeights, Paragraph } from '@va/ui/design-system';
import classNames from 'classnames';

type BadgeProps = {
  label: string;
  /** Background of the pill, and any padding that should replace the default. */
  className?: string;
  /** Label color, following the `Paragraph` convention. */
  colorClassName?: string;
};

export const Badge = ({ label, className, colorClassName }: BadgeProps) => {
  return (
    <div className={classNames('w-fit rounded-full px-3 py-0.5', className)}>
      <Paragraph weight={fontWeights.medium} colorClassName={colorClassName} className='whitespace-nowrap'>
        {label}
      </Paragraph>
    </div>
  );
};
